(function () {
'use strict';

var VALID_PATTERNS = [
'Catastrophizer',
'Performer',
'Protector',
'Fortress',
'Optimizer',
'Seeker'
];

function initAssessment(section) {
if (
!section ||
section.getAttribute('data-assessment-initialized') === 'true'
) {
return;
}

section.setAttribute('data-assessment-initialized', 'true');

var endpoint = section.getAttribute('data-assess-endpoint');
var intro = section.querySelector('[data-assess-intro]');
var startButton = section.querySelector('[data-assess-start-btn]');
var form = section.querySelector('[data-assess-form]');
var screens = Array.prototype.slice.call(
section.querySelectorAll('[data-assess-screen]')
);
var progressBar = section.querySelector('[data-assess-progress-bar]');
var stepLabel = section.querySelector('[data-assess-step-label]');
var liveStatus = section.querySelector('[data-assess-live-status]');
var backButton = section.querySelector('[data-assess-back-btn]');
var captureScreen = section.querySelector(
'[data-assess-capture-screen]'
);
var captureBack = section.querySelector('[data-assess-capture-back]');
var emailInput = section.querySelector('[data-assess-email]');
var emailError = section.querySelector('[data-assess-email-error]');
var privacyConsentInput = section.querySelector(
'[data-assess-privacy-consent]'
);
var privacyConsentError = section.querySelector(
'[data-assess-privacy-consent-error]'
);
var consentInput = section.querySelector('[data-assess-consent]');
var consentError = section.querySelector(
'[data-assess-consent-error]'
);
var honeypot = section.querySelector('[data-assess-honeypot]');
var submitButton = section.querySelector('[data-assess-submit-btn]');
var originalSubmitLabel = submitButton
? submitButton.textContent
: 'See My Result';
var submitError = section.querySelector('[data-assess-submit-error]');
var resultScreen = section.querySelector('[data-assess-result]');
var resultContent = section.querySelector(
'[data-assess-result-content]'
);
var emailConfirmation = section.querySelector(
'[data-assess-email-confirmation]'
);
var templatesRoot = section.querySelector(
'[data-assess-result-templates]'
);

var answers = new Array(screens.length).fill(null);
var currentStep = 0;
var submitting = false;

function scrollToSection() {
section.scrollIntoView({
behavior: 'smooth',
block: 'start'
});
}

function updateProgress() {
if (progressBar) {
progressBar.style.width =
(((currentStep + 1) / screens.length) * 100) + '%';
}

if (stepLabel) {
stepLabel.textContent =
'Question ' + (currentStep + 1) + ' of ' + screens.length;
}

if (backButton) {
backButton.disabled = currentStep === 0;
}

if (liveStatus) {
liveStatus.textContent =
'Question ' + (currentStep + 1) + ' of ' + screens.length;
}
}

function showQuestion(index, shouldScroll) {
if (index < 0 || index >= screens.length) {
return;
}

currentStep = index;

screens.forEach(function (screen, screenIndex) {
screen.classList.toggle('active', screenIndex === index);
});

if (captureScreen) {
captureScreen.style.display = 'none';
}

updateProgress();

if (shouldScroll !== false) {
scrollToSection();
}
}

function showCapture() {
screens.forEach(function (screen) {
screen.classList.remove('active');
});

if (captureScreen) {
captureScreen.style.display = 'block';
}

if (progressBar) {
progressBar.style.width = '100%';
}

if (stepLabel) {
stepLabel.textContent = 'Last step';
}

if (backButton) {
backButton.disabled = true;
}

if (liveStatus) {
liveStatus.textContent =
'All questions complete. Last step.';
}

scrollToSection();

if (emailInput) {
emailInput.focus();
}
}

function setSubmitError(message) {
if (!submitError) {
return;
}

submitError.textContent = message || '';
submitError.style.display = message ? 'block' : 'none';
}

function setSubmittingState(isSubmitting) {
submitting = isSubmitting;

if (submitButton) {
submitButton.disabled = isSubmitting;

submitButton.setAttribute(
'aria-disabled',
isSubmitting ? 'true' : 'false'
);

submitButton.textContent = isSubmitting
? 'Loading your result…'
: originalSubmitLabel;
}

if (emailInput) {
emailInput.disabled = isSubmitting;
}

if (privacyConsentInput) {
privacyConsentInput.disabled = isSubmitting;
}

if (consentInput) {
consentInput.disabled = isSubmitting;
}
}

function validEmail(value) {
if (!value) {
return false;
}

var testInput = document.createElement('input');
testInput.type = 'email';
testInput.value = value;

return testInput.checkValidity();
}

function showResult(
pattern,
mailchimpOk,
mailchimpSkipped,
resultEmailOk
) {
if (
VALID_PATTERNS.indexOf(pattern) === -1 ||
!templatesRoot ||
!resultContent ||
!resultScreen
) {
throw new Error('Invalid assessment result returned');
}

var template = templatesRoot.querySelector(
'template[data-pattern-template="' + pattern + '"]'
);

if (!template) {
throw new Error('Assessment result content is missing');
}

resultContent.innerHTML = '';

resultContent.appendChild(
template.content.cloneNode(true)
);

if (emailConfirmation) {
if (mailchimpOk) {
emailConfirmation.textContent = resultEmailOk
? 'Your result is shown above and a copy has been emailed to you from Simon Hitchcock. Check your inbox for a separate confirmation from The Ridge if you chose to join Simon’s email list.'
: 'Your result is shown above. Check your inbox for a confirmation from The Ridge if you chose to join Simon’s email list.';
} else if (mailchimpSkipped) {
emailConfirmation.textContent = resultEmailOk
? 'Your result is shown above and a copy has been emailed to you from Simon Hitchcock.'
: 'Your result is shown above.';
} else {
emailConfirmation.textContent = resultEmailOk
? 'Your result is shown above and a copy has been emailed to you from Simon Hitchcock. There was a problem adding you to Simon’s email list.'
: 'Your result is shown above. There was a problem sending your email copy and adding you to Simon’s email list.';
}
}

if (intro) {
intro.style.display = 'none';
}

if (form) {
form.style.display = 'none';
}

resultScreen.style.display = 'block';
resultScreen.focus();

resultScreen.scrollIntoView({
behavior: 'smooth',
block: 'start'
});
}

if (startButton) {
startButton.addEventListener('click', function () {
if (intro) {
intro.style.display = 'none';
}

if (form) {
form.style.display = 'block';
}

showQuestion(0, true);
});
}

screens.forEach(function (screen, screenIndex) {
screen
.querySelectorAll('[data-assess-input]')
.forEach(function (input) {
input.addEventListener('change', function () {
answers[screenIndex] = input.value;

window.setTimeout(function () {
if (screenIndex < screens.length - 1) {
showQuestion(screenIndex + 1, true);
} else {
showCapture();
}
}, 180);
});
});
});

if (backButton) {
backButton.addEventListener('click', function () {
if (currentStep > 0) {
showQuestion(currentStep - 1, true);
}
});
}

if (captureBack) {
captureBack.addEventListener('click', function () {
showQuestion(screens.length - 1, true);
});
}

if (emailInput) {
emailInput.addEventListener('input', function () {
if (emailError) {
emailError.style.display = 'none';
}

setSubmitError('');
});
}

if (privacyConsentInput) {
privacyConsentInput.addEventListener('change', function () {
if (privacyConsentError) {
privacyConsentError.style.display = 'none';
}

setSubmitError('');
});
}

if (consentInput) {
consentInput.addEventListener('change', function () {
if (consentError) {
consentError.style.display = 'none';
}

setSubmitError('');
});
}

if (form) {
form.addEventListener('submit', function (event) {
event.preventDefault();

if (submitting) {
return;
}

setSubmitError('');

if (honeypot && honeypot.value.trim() !== '') {
setSubmitError(
'Something went wrong. Please refresh and try again.'
);

return;
}

var missingAnswerIndex = answers.findIndex(
function (answer) {
return answer === null;
}
);

if (missingAnswerIndex !== -1) {
showQuestion(missingAnswerIndex, true);
return;
}

var email = emailInput
? emailInput.value.trim()
: '';

var emailIsValid = validEmail(email);

if (emailError) {
emailError.style.display =
emailIsValid ? 'none' : 'block';
}

var privacyConsent = !!(
privacyConsentInput &&
privacyConsentInput.checked
);

if (privacyConsentError) {
privacyConsentError.style.display =
privacyConsent ? 'none' : 'block';
}

var marketingConsent = !!(
consentInput &&
consentInput.checked
);

if (consentError) {
consentError.style.display = 'none';
}

if (!emailIsValid) {
if (emailInput) {
emailInput.focus();
}

return;
}

if (!privacyConsent) {
if (privacyConsentInput) {
privacyConsentInput.focus();
}

return;
}

if (!endpoint) {
setSubmitError(
'The assessment connection is not configured. Please try again later.'
);

return;
}

setSubmittingState(true);

var controller = new AbortController();

var timeoutId = window.setTimeout(function () {
controller.abort();
}, 20000);

fetch(endpoint, {
method: 'POST',
mode: 'cors',
credentials: 'omit',
headers: {
'Content-Type': 'application/json',
'Accept': 'application/json'
},
body: JSON.stringify({
email: email,
answers: answers,
marketingConsent: marketingConsent
}),
signal: controller.signal
})
.then(function (response) {
return response.text().then(function (text) {
var body = {};

try {
body = text ? JSON.parse(text) : {};
} catch (parseError) {
body = {};
}

if (!response.ok) {
throw new Error(
body && body.error
? body.error
: 'The assessment could not be submitted. Please try again.'
);
}

return body;
});
})
.then(function (body) {
if (
!body ||
body.success !== true ||
VALID_PATTERNS.indexOf(body.pattern) === -1
) {
throw new Error(
'The assessment returned an invalid response. Please try again.'
);
}

showResult(
body.pattern,
body.mailchimpOk === true,
body.mailchimpSkipped === true,
body.resultEmailOk === true
);
})
.catch(function (error) {
console.error(
'Assessment submission failed:',
error
);

if (error && error.name === 'AbortError') {
setSubmitError(
'The connection timed out. Please check your internet connection and try again.'
);
} else {
setSubmitError(
error && error.message
? error.message
: 'Something went wrong. Please try again.'
);
}
})
.finally(function () {
window.clearTimeout(timeoutId);
setSubmittingState(false);
});
});
}

updateProgress();
}

function initAllAssessments(scope) {
var root = scope || document;

root
.querySelectorAll('[data-assessment-section]')
.forEach(initAssessment);
}

initAllAssessments(document);

document.addEventListener(
'shopify:section:load',
function (event) {
initAllAssessments(event.target);
}
);
})();
